import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Checkbox, DatePicker, Form, Select, Spin, Table } from "antd";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import moment from "moment";
import logo from "../../assets/images/logo.png";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import "../ProducList/productList.css";
import { TabTitle } from "../../utils/GeneralFunction.js";
import { getDropshipLocationByZip } from "../../redux/actions/dropshipSummaryReports.action.js";
import { getGender } from "../../redux/actions/gender.action.js";
import { getAdminLocation } from "../../redux/actions/adminLocation.action.js";
import { getZip } from "../../redux/actions/zip.action.js";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min.js";

const DropshipLocationByZip = ({ token }) => {
  TabTitle("DropShip SKU")
  const userName = ReadCookie("name");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);
  const { gender, dropshipLocationByZip, zip } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const [excelData, setExcelData] = useState([]);
  const [allStatus, setAllStatus] = useState(true);
  const [allFilters, setAllFilters] = useState([
    { id: 1590056, name: "Amazon Seller Central", selected: false },
    { id: 1516580, name: "Moda Operandi", selected: false },
    { id: 70550, name: "Nordstrom D2C", selected: false },
    { id: 1628656, name: "Nordstrom Marketplace", selected: false },
    { id: 85782, name: "Saks Dropship", selected: false },
    // { id: 1429711, name: "Saks Marketplace", selected: false },
    { id: 42989, name: "Maisonette, Inc", selected: false },
    { id: 1625777, name: "Bloomingdales-Dropship", selected: false },
    { id: 1628081, name: "Anthropologie Dropship", selected: false },
    { id: 1628193, name: "Maison Rogue", selected: false },
    { id: 1634633, name: "Army & Air Force Exchange Service", selected: false },
    { id: 1634213, name: "Rent the Runway Marketplace", selected: false },
    { id: 1, name: "Ecommerce", selected: false },
  ]);

  const statusSelectAll = (e) => {
    let copyArr = [...allFilters];
    copyArr.map((v) => {
      v.selected = false;;
      return v;
    });
    setAllFilters(copyArr);
    setAllStatus(e.target.checked);
  };



  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let fromDate = query.get("from_date");
  let toDate = query.get("to_date");
  let genderID = query.get("gender_id");
  let zipCode = query.get("zip_code");
  let customer = query.get("customer_id");


  useEffect(() => {
    let initialValues = {
      from_date: fromDate ? moment(fromDate, "MM-DD-YYYY") : moment().startOf("year"),
      to_date: toDate ? moment(toDate, "MM-DD-YYYY") : moment().endOf("year"),
      gender_id: genderID && genderID !== "null" ? Number(genderID) : "All",
      zip: zipCode && zipCode !== "null" ? zipCode : "All",
    };

    // if (customer && allFilters.length > 0) {
    //   let copyArr = allFilters.map((item) => ({
    //     ...item,
    //     selected: item.id.toString() === customer.toString(),
    //   }));
    //   setAllFilters(copyArr);
    //   setAllStatus(false);
    // }

    if (allFilters.length > 0) {
      if (customer && customer !== "null") {
        // 👈 agar ek specific customer param me aya
        let copyArr = allFilters.map((item) => ({
          ...item,
          selected: item.id.toString() === customer.toString(),
        }));
        setAllFilters(copyArr);
        setAllStatus(false);
      } else {
        // 👈 agar customer param "null" ho ya na ho
        let copyArr = allFilters.map((item) => ({
          ...item,
          selected: false,
        }));
        setAllFilters(copyArr);
        setAllStatus(true); // ✅ All checkbox tick ho jayega
      }
    }

    form.setFieldsValue(initialValues);
  }, []);


  useEffect(() => {
    if (fromDate && toDate) {
      setLoading(true);
      let values = {
        from_date: fromDate,
        to_date: toDate,
        gender_id: genderID === "null" || genderID === "All" ? null : genderID,
        zip: zipCode === "null" || zipCode === "All" ? null : zipCode,
        report: customer && customer !== "null" ? [customer] : [],  // 👈 fix here
      };
      dispatch(getDropshipLocationByZip(token, values)).then((res) => {
        if (res.type === "GET_DROPSHIP_LOCATION_BY_ZIP_REPORTS_SUCCESS") {
          downloadExcelFileData(res?.payload?.data);
        }
        setLoading(false);
      });
    }
  }, [fromDate, toDate, genderID, zipCode, customer, dispatch, token]);




  const onFinish = async () => {
    setLoading(true);
    await form.validateFields().then((values) => {
      let report = allFilters
        .filter((item) => item.selected === true)
        .map((item) => item.id);
      values.report = report.length > 0 ? report : [];
      dispatch(getDropshipLocationByZip(token, values)).then((res) => {
        if (res.type === "GET_DROPSHIP_LOCATION_BY_ZIP_REPORTS_SUCCESS") {
          downloadExcelFileData(res?.payload?.data);
          setLoading(false);
        }
      });
    }).catch((error) => {
      setLoading(false);
    })
  }

  useEffect(() => {
    dispatch(getGender(token, menuId));
    dispatch(getAdminLocation(token, menuId));
    dispatch(getZip(token));
  }, [dispatch, menuId, token]);

  const handlePrint = () => {
    window.print();
  };


  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "Country": v.country_name,
          "State": v.state_name,
          "City": v.city_name,
          "Zip": v.zip_code,
          "SKU": v.sku,
          "Inseam": v.inseam,
          "Style": v.style_name,
          "Wash": v.wash_name,
          "Current Season": v.new_season,
          "SHP U": v.shipped_qty,
          "RTRN U": v.returned_qty,
          "NET U": v.net_qty,
        };
      })
    );
  }

  const columns = [
    {
      title: "#",
      className: "b_bottom",
      render: (text, record, index) => {
        return index + 1
      },
    },
    {
      title: "Country",
      dataIndex: "country_name",
      key: "country_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.country_name !== null) & (b.country_name !== null)) {
          return a.country_name.localeCompare(b.country_name);
        }
      }
    },
    {
      title: "State",
      dataIndex: "state_name",
      key: "state_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.state_name !== null) & (b.state_name !== null)) {
          return a.state_name.localeCompare(b.state_name);
        }
      }
    },
    {
      title: "City",
      dataIndex: "city_name",
      key: "city_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.city_name !== null) & (b.city_name !== null)) {
          return a.city_name.localeCompare(b.city_name);
        }
      }
    },
    {
      title: "Zip Code",
      dataIndex: "zip_code",
      key: "zip_code",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.zip_code - b.zip_code
      },
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.sku.localeCompare(b.sku)
      },
    },
    {
      title: "Inseam",
      dataIndex: "inseam",
      key: "inseam",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.inseam - b.inseam
      },
    },
    {
      title: "Style",
      dataIndex: "style_name",
      key: "style_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.style_name !== null) & (b.style_name !== null)) {
          return a.style_name.localeCompare(b.style_name);
        }
      }
    },
    {
      title: "Wash",
      dataIndex: "wash_name",
      key: "wash_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.wash_name !== null) & (b.wash_name !== null)) {
          return a.wash_name.localeCompare(b.wash_name);
        }
      }
    },
    {
      title: "Current Season",
      dataIndex: "new_season",
      key: "new_season",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.new_season !== null) & (b.new_season !== null)) {
          return a.new_season.localeCompare(b.new_season);
        }
      }
    },
    {
      title: "SHP U",
      dataIndex: "shipped_qty",
      key: "shipped_qty",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.shipped_qty - b.shipped_qty
      },
    },
    {
      title: "RTRN U",
      dataIndex: "returned_qty",
      key: "returned_qty",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.returned_qty - b.returned_qty
      },
    },
    {
      title: "NET U",
      dataIndex: "net_qty",
      key: "net_qty",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        return a.net_qty - b.net_qty
      },
    },
    // {
    //   title: "NET $",
    //   dataIndex: "net_amount",
    //   key: "net_amount",
    //   className: " b_left b_bottom",
    //   align: "right",
    //   render: (text, record) => {
    //     return (
    //       <>
    //         $ {text}
    //       </>
    //     );
    //   },
    //   sorter: (a, b) => {
    //     return a.net_amount - b.net_amount
    //   },
    // },
    // {
    //   title: "AUC",
    //   dataIndex: "auc",
    //   key: "auc",
    //   className: " b_left b_bottom",
    //   align: "right",
    //   render: (text, record) => {
    //     return (
    //       <>
    //         {text}
    //       </>
    //     );
    //   },
    //   sorter: (a, b) => {
    //     return a.auc - b.auc
    //   },
    // },
    // {
    //   title: "RET %",
    //   dataIndex: "ret_rate_per",
    //   key: "ret_rate_per",
    //   className: " b_left b_bottom",
    //   align: "right",
    //   render: (text, record) => {
    //     return (
    //       <>
    //         {text} %
    //       </>
    //     );
    //   },
    //   sorter: (a, b) => {
    //     return a.ret_rate_per - b.ret_rate_per
    //   },
    // },
    // {
    //   title: "D2C",
    //   dataIndex: "d2c",
    //   key: "d2c",
    //   className: " b_left b_bottom",
    //   align: "right",
    //   render: (text, record) => {
    //     return (
    //       <>
    //         {text}
    //       </>
    //     );
    //   },
    //   sorter: (a, b) => {
    //     return a.d2c - b.d2c
    //   },
    // },
    // {
    //   title: "Bergen",
    //   dataIndex: "bergen",
    //   key: "bergen",
    //   className: " b_left b_bottom",
    //   align: "right",
    //   render: (text, record) => {
    //     return (
    //       <>
    //         {text}
    //       </>
    //     );
    //   },
    //   sorter: (a, b) => {
    //     return a.bergen - b.bergen
    //   },
    // },
  ];


  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between pb-0">
                <div className="col-3 d-flex align-items-start  box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>

                <div className="col-3 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class">
                      <div className="print_icon printing_class">
                        <i
                          id="Image1"
                          title="Print"
                          alt="Print"
                          className="fa-solid fa-print printing_class"
                          onClick={handlePrint}
                        ></i>
                      </div>
                      <div className="print_icon printing_class">
                        {dropshipLocationByZip?.payload?.data ? (
                          <CSVLink
                            filename={"Dropship-Location-By-Zip.csv"}
                            data={excelData}
                            onClick={() => { }}
                          >
                            <input
                              type="image"
                              name="ImgExcel"
                              alt="Export to excel"
                              id="ImgExcel"
                              title="Export to excel"
                              src={xlsx}
                              style={{ borderWidth: "0px", height: "14px" }}
                            />
                          </CSVLink>
                        ) : (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                          />
                        )}
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      Dropship Location By Zip
                      <br />
                      Rpt # 006
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>

                    </span>
                  </div>
                </div>
              </div>
              <div className="row pb-2">
                <div className="col">
                  <Form
                    // labelCol={{ span: 6 }}
                    // wrapperCol={{ span: 18 }}
                    // layout="horizontal"
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                  >
                    <div className="main_form row">
                      <div className="col-12">
                        <hr className="my-1" />
                        <div
                        // className="row"
                        >
                          <label htmlFor="" style={{ marginRight: "25px" }}>Customer</label>
                          <div className="checkboxes">
                            <div className="checkbox_content">
                              <Form.Item name="customer_id" className=" mb-0">
                                <Checkbox
                                  checked={allStatus} onChange={statusSelectAll}
                                >
                                  All
                                </Checkbox>
                              </Form.Item>
                            </div>
                            {allFilters &&
                              allFilters.map((it, index) => {
                                return (
                                  <div key={index} className="checkbox_content">
                                    <Form.Item name="customer_id">
                                      <Checkbox
                                        checked={it.selected}


                                        onChange={(e) => {
                                          let copyArr = [...allFilters];
                                          if (e.target.checked) {
                                            copyArr[index].selected = true;
                                          } else {
                                            copyArr[index].selected = false;
                                          }
                                          setAllFilters(copyArr);
                                          setAllStatus(false);
                                        }}
                                      >
                                        {it.name}
                                      </Checkbox>
                                    </Form.Item>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                        <hr className="my-1" />
                        <div className="row">
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="gender_id" className="labels width30">
                                From:
                              </label>
                              <div style={{ marginBottom: "-2px" }} className=" w-100">
                                <Form.Item
                                  className="formFullWidth"
                                  name="from_date"
                                  initialValue={moment().startOf("year")}
                                >
                                  <DatePicker
                                    size="small"
                                    defaultValue={moment().format("MM-DD-YYYY")}
                                    className={"select_Inputs"}
                                    format={"MM-DD-YYYY"}
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className=" col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="gender_id" className="labels width30">
                                To:
                              </label>
                              <div style={{ marginBottom: "-2px" }} className=" w-100">
                                <Form.Item
                                  className="formFullWidth"
                                  name="to_date"
                                  initialValue={moment().endOf("year")}
                                >
                                  <DatePicker
                                    size="small"
                                    defaultValue={moment().format("MM-DD-YYYY")}
                                    className={"select_Inputs"}
                                    format={"MM-DD-YYYY"}
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width30">Gender:</label>
                              <div className=" w-100">
                                <Form.Item name="gender_id" initialValue={"All"}>
                                  <Select
                                    className={"select_Inputs"}
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value="All">All</Option>
                                    {gender &&
                                      gender?.payload?.data.map((it, index) => {
                                        return (
                                          <Option key={index} value={it.gender_id}>
                                            {it.gender_name}
                                          </Option>
                                        );
                                      })}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <div className=" d-flex flex-row align-items-baseline">
                              <label htmlFor="" className="labels width30">Zip:</label>
                              <div className=" w-100">
                                <Form.Item name="zip" initialValue={"All"}>
                                  <Select
                                    className={"select_Inputs"}
                                    showSearch
                                    optionFilterProp="children"
                                    size="small"
                                  >
                                    <Option value="All">All</Option>
                                    {zip &&
                                      zip?.payload?.data.map((it, index) => {
                                        return (
                                          <Option key={index} value={it.zip_code}>
                                            {it.zip_code}
                                          </Option>
                                        );
                                      })}
                                  </Select>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12">
                            <div className="row">
                              <div style={{ marginTop: "3px", display: "flex", justifyContent: "right" }} >
                                <Button type="primary" htmlType="submit" className='submit-btn-btm m-0' disabled={loading}>
                                  Search
                                </Button>
                                {/* </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table_content"
        style={{ width: '75%' }}
        ref={tableRef} >
        <div>
          {loading ? (
            <div className="d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin />
            </div>
          ) : dropshipLocationByZip?.payload?.data.length ? (
            // Loop through each state group and render a table

            <Table
              style={{ fontSize: '10.3px' }}
              className="test04 mt-3 sales_target_report_table sales_report_res_table_intransit ledger_print speciality_customer_size sales_report_res_table"
              size="small"
              pagination={{
                defaultCurrent: 1,
                defaultPageSize: 100,
                pageSizeOptions: [100, 500, 1000]
              }}
              summary={pageData => {
                let shipQty = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.shipped_qty)
                }, 0);
                let returnQty = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.returned_qty)
                }, 0);
                let netQty = pageData.reduce(function (previousValue, currentValue) {
                  return previousValue += parseFloat(currentValue.net_qty)
                }, 0);
                // let netAmount = pageData.reduce(function (previousValue, currentValue) {
                //   return previousValue += parseFloat(currentValue.net_amount)
                // }, 0);
                // let auc = pageData.reduce(function (previousValue, currentValue) {
                //   return previousValue += parseFloat(currentValue.auc)
                // }, 0);
                // let d2c = pageData.reduce(function (previousValue, currentValue) {
                //   return previousValue += parseFloat(currentValue.d2c)
                // }, 0);
                // let bergen = pageData.reduce(function (previousValue, currentValue) {
                //   return previousValue += parseFloat(currentValue.bergen)
                // }, 0);
                return (
                  <>
                    <Table.Summary.Row>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell></Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right" }}>Total</p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(shipQty.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(returnQty.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(netQty.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      {/* <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          $ {numeral(netAmount.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral((netAmount / netQty).toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(((returnQty / shipQty) * 100).toLocaleString("en-US")).format("0,00")} %
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(d2c.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell className="sales_table_summary">
                        <p style={{ fontWeight: "bolder", textAlign: "right", width: "100%", borderTop: "1px solid black", borderBottom: "1px solid black", fontSize: "11.3px" }}>
                          {numeral(bergen.toLocaleString("en-US")).format("0,00")}
                        </p>
                      </Table.Summary.Cell> */}
                    </Table.Summary.Row>
                  </>
                );
              }}
              bordered
              columns={columns}
              // scroll={{ x: 'max-content' }}
              dataSource={dropshipLocationByZip?.payload?.data}
              loading={dropshipLocationByZip?.loading}
            />
          ) : (
            <div
              style={{
                backgroundColor: '#CCCCCC',
                borderWidth: '1pt',
                borderStyle: 'Dashed',
                fontWeight: 'bold',
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No record(s)
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DropshipLocationByZip;

